import { MarketingApi } from '../MarketingApi'
import { submitAndRoute } from '../concierge'
import { Optional, Options } from '../types'

export const deployMarketo = (options: Optional<Options, 'form'>) => {
  if (window.MktoForms2) {
    const marketingApi = new MarketingApi(options)
    window.MktoForms2.whenReady((form: any) => {
      const submittedFormId = (form.getId().toString() as string).replace('mktoForm_', '')
      const formId = (() => {
        if (options.formId) {
          return options.formId
        }
        if (options.formIds?.length) {
          return options.formIds.find(formId => formId.replace('mktoForm_', '') === submittedFormId)
        }
        return submittedFormId
      })()
      const formElement = document.querySelector<HTMLFormElement>(`form[id="mktoForm_${formId}"]`)
      if (formElement) {
        marketingApi.prelaunch.enrichmentParentSelector = '.mktoFormRow'
        marketingApi.setForm(formElement)
      }
      form.onSuccess((values: any) => {
        if (formId === submittedFormId) {
          submitAndRoute(
            {
              ...options,
              map: true,
              lead: {
                ...values,
                ...(options.lead ?? {}),
              },
            },
            marketingApi
          )
          return false
        }
        // eslint-disable-next-line no-console
        console.log(`Submitted form ID ${submittedFormId} is not in the options`)
        return true
      })
    })
  }
}
